import {createReducer} from '@reduxjs/toolkit';
import {
    getOverageEnabledRequest,
    getOverageEnabledSuccess,
    updateOverageStatusSuccess,
} from 'src/openapi/admin/apis/OverageSettingsControllerApi';

import type {OverageSettings} from 'src/openapi/admin/models/OverageSettings';

export type State = {
    [accountId: number]: OverageSettings | null,
};

const defaultState: State = {};

export const overageStatus = createReducer(defaultState, builder => builder
    .addCase(getOverageEnabledRequest, (state, action) => {
        return {
            ...state,
            [action.payload.meta.accountId]: null,
        };
    })
    .addCase(getOverageEnabledSuccess, (state, action) => {
        return {
            ...state,
            [action.payload.meta.accountId]: action.payload.data,
        };
    })
    .addCase(updateOverageStatusSuccess, (state, action) => {
        const stateElement = state[action.payload.meta.accountId];
        const settings = action.payload.meta.overageSettings;

        if (stateElement) {
            return {
                ...state,
                [action.payload.meta.accountId]: {
                    ...stateElement,
                    ...settings,
                },
            };
        }

        return state;
    }),
);
